module.exports = __webpack_public_path__ + "static/media/cloud-rain.fc198dd0.svg";